// Read the csrftoken cookie set by Django's CsrfViewMiddleware.
export function getCsrfToken(): string {
  const match = document.cookie
    .split('; ')
    .find((c) => c.startsWith('csrftoken='));
  return match ? match.split('=')[1] : '';
}

// Ensure a csrftoken cookie exists by hitting the bootstrap endpoint.
// Safe to call on app boot — returns the token once Django has set the cookie.
export async function ensureCsrfToken(): Promise<string> {
  let token = getCsrfToken();
  if (token) return token;
  await fetch('/api/csrf/', { credentials: 'include' });
  token = getCsrfToken();
  return token;
}
